export default __webpack_public_path__ + "static/TuP-8ef363e5d50e242659209951faa36ce5.png";